export default __webpack_public_path__ + "static/media/qampus.af0be152.png";